"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var arrayExtensions_1 = require("spry-react/utils/arrayExtensions");
var NotSelectableStrategy = /** @class */ (function () {
    function NotSelectableStrategy() {
        this.allowsSelection = false;
        this.isKeySelected = function (selectionKey) {
            return false;
        };
        this.isKeySelectable = function (selectionKey) {
            return false;
        };
        this.areAllKeysSelected = function (allSelectableKeys) {
            return false;
        };
        this.toggleKeySelection = function (selectionKey) { };
        this.toggleAllKeys = function (allSelectableKeys) { };
        this.selectOnly = function (selectionKey) { };
    }
    return NotSelectableStrategy;
}());
exports.NotSelectableStrategy = NotSelectableStrategy;
var BaseSelectStategy = /** @class */ (function () {
    function BaseSelectStategy(currentlySelectedKeys, selectionToggledCallback, disabledKeys) {
        var _this = this;
        this.allowsSelection = true;
        this.isKeySelected = function (selectionKey) {
            return _this.selectedKeys.indexOf(selectionKey) > -1;
        };
        this.isKeySelectable = function (selectionKey) {
            return _this.disabledKeys.indexOf(selectionKey) === -1;
        };
        this.areAllKeysSelected = function (allSelectableKeys) {
            /* if all the specified keys are disabled and selected, return true */
            if (allSelectableKeys.length > 0 && allSelectableKeys.every(function (key) { return _this.disabledKeys.indexOf(key) > -1 && _this.selectedKeys.indexOf(key) > -1; })) {
                return true;
            }
            /* if any of the keys are enabled, only those keys must be selected */
            var enabledSelectableKeys = allSelectableKeys.filter(function (key) { return _this.disabledKeys.indexOf(key) === -1; });
            return enabledSelectableKeys.length > 0 && enabledSelectableKeys.every(function (key) { return _this.selectedKeys.indexOf(key) > -1; });
        };
        this.toggleAllKeys = function (allSelectableKeys) {
            var enabledSelectableKeys = allSelectableKeys.filter(function (key) { return _this.disabledKeys.indexOf(key) === -1; });
            var selectedDisabledKeys = _this.selectedKeys.filter(function (key) { return _this.disabledKeys.indexOf(key) > -1; });
            if (_this.areAllKeysSelected(enabledSelectableKeys)) {
                _this.selectionToggledCallback(selectedDisabledKeys);
            }
            else {
                _this.selectionToggledCallback(enabledSelectableKeys.concat(selectedDisabledKeys));
            }
        };
        this.selectSingleKey = function (selectionKey) {
            if (_this.disabledKeys.indexOf(selectionKey) > -1) {
                return _this.selectedKeys;
            }
            var selectedDisabledKeys = _this.selectedKeys.filter(function (key) { return _this.disabledKeys.indexOf(key) > -1; });
            if (_this.isKeySelected(selectionKey)) {
                return selectedDisabledKeys;
            }
            else {
                return [selectionKey].concat(selectedDisabledKeys);
            }
        };
        this.addOrRemoveKey = function (selectionKey) {
            if (_this.disabledKeys.indexOf(selectionKey) > -1) {
                return _this.selectedKeys;
            }
            var selectedKeysCopy = arrayExtensions_1.clone(_this.selectedKeys);
            if (_this.isKeySelected(selectionKey)) {
                var existingKeyIndex = selectedKeysCopy.indexOf(selectionKey);
                selectedKeysCopy.splice(existingKeyIndex, 1);
            }
            else {
                selectedKeysCopy.push(selectionKey);
            }
            return selectedKeysCopy;
        };
        this.selectedKeys = currentlySelectedKeys;
        this.selectionToggledCallback = selectionToggledCallback;
        this.disabledKeys = disabledKeys || [];
    }
    return BaseSelectStategy;
}());
exports.BaseSelectStategy = BaseSelectStategy;
var SingleSelectStrategy = /** @class */ (function (_super) {
    __extends(SingleSelectStrategy, _super);
    function SingleSelectStrategy(currentlySelectedKeys, selectionToggledCallback, disabledKeys) {
        var _this = _super.call(this, currentlySelectedKeys, selectionToggledCallback, disabledKeys) || this;
        _this.toggleKeySelection = function (selectionKey) {
            /* if the currently selected key is disabled, it will remain as the selected item and another item cannot be selected */
            if (_this.selectedKeys.length > 0 && _this.selectedKeys.every(function (key) { return _this.disabledKeys.indexOf(key) > -1; })) {
                return;
            }
            var newSetOfSelectedKeys = _this.selectSingleKey(selectionKey);
            _this.selectionToggledCallback(newSetOfSelectedKeys);
        };
        //This doesn't do anything because there shouldn't be a Select All/None option when using a SingleSelectStrategy
        _this.toggleAllKeys = function (allSelectableKeys) { };
        _this.selectOnly = function (selectionKey) {
            _this.toggleKeySelection(selectionKey);
        };
        return _this;
    }
    return SingleSelectStrategy;
}(BaseSelectStategy));
exports.SingleSelectStrategy = SingleSelectStrategy;
var OptionalMultiSelectStrategy = /** @class */ (function (_super) {
    __extends(OptionalMultiSelectStrategy, _super);
    function OptionalMultiSelectStrategy(currentlySelectedKeys, selectionToggledCallback, disabledKeys) {
        var _this = _super.call(this, currentlySelectedKeys, selectionToggledCallback, disabledKeys) || this;
        _this.toggleKeySelection = function (selectionKey, e) {
            var newSetOfSelectedKeys = e.ctrlKey
                ? _this.addOrRemoveKey(selectionKey)
                : _this.selectSingleKey(selectionKey);
            _this.selectionToggledCallback(newSetOfSelectedKeys);
        };
        _this.selectOnly = function (selectionKey) {
            var selectedKeys = _this.selectSingleKey(selectionKey);
            _this.selectionToggledCallback(selectedKeys);
        };
        return _this;
    }
    return OptionalMultiSelectStrategy;
}(BaseSelectStategy));
exports.OptionalMultiSelectStrategy = OptionalMultiSelectStrategy;
var ForcedMultiSelectStrategy = /** @class */ (function (_super) {
    __extends(ForcedMultiSelectStrategy, _super);
    function ForcedMultiSelectStrategy(currentlySelectedKeys, selectionToggledCallback, disabledKeys) {
        var _this = _super.call(this, currentlySelectedKeys, selectionToggledCallback, disabledKeys) || this;
        _this.toggleKeySelection = function (selectionKey) {
            var newSetOfSelectedKeys = _this.addOrRemoveKey(selectionKey);
            _this.selectionToggledCallback(newSetOfSelectedKeys);
        };
        _this.selectOnly = function (selectionKey) {
            var selectedKeys = _this.selectSingleKey(selectionKey);
            _this.selectionToggledCallback(selectedKeys);
        };
        return _this;
    }
    return ForcedMultiSelectStrategy;
}(BaseSelectStategy));
exports.ForcedMultiSelectStrategy = ForcedMultiSelectStrategy;
